export const communitySelect = {
  data() {
    return {};
  },
  created() {},
  computed: {
    mixinCommunityId() {
      return this.$store.state.community.selectedCommunity.id;
    },
  },
  methods: {},
  watch: {
    //run init() when communityId change
    mixinCommunityId() {
      console.log('MIXIN:Run init when communityId change');
      //this.init();
    },
  },
};
